import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["knob", "iconLight", "iconDark"]

  toggle() {
    const isDark = document.documentElement.classList.toggle("dark")
    document.cookie = `theme=${isDark ? "dark" : "light"};path=/;max-age=31536000`
    this.updateState(isDark)
  }

  connect() {
    const isDark = document.documentElement.classList.contains("dark")
    this.updateState(isDark)
  }

  updateState(isDark) {
    if (this.hasKnobTarget) {
      if (isDark) {
        this.knobTarget.classList.remove("translate-x-6")
        this.knobTarget.classList.add("translate-x-0")
      } else {
        this.knobTarget.classList.remove("translate-x-0")
        this.knobTarget.classList.add("translate-x-6")
      }
    }
    if (this.hasIconLightTarget && this.hasIconDarkTarget) {
      this.iconLightTarget.classList.toggle("hidden", isDark)
      this.iconDarkTarget.classList.toggle("hidden", !isDark)
    }
  }
}
